import { Card } from "antd";
import { Component } from "react";

import { cn } from "@btnet/utilities-core";

import "./PrintGroup.less";

interface IProps {
    /**
     * Title
     */
    title: JSX.Element | string;
    /**
     * Style
     */
    style?: React.CSSProperties;
    className?: string;
    /**
     * Avoid page break inside this PrintGroup
     * @default true
     */
    avoidPageBreak: boolean;
    /**
     */
    align?: "left" | "center";
    children: React.ReactNode;
}

export class PrintGroup extends Component<IProps> {
    static defaultProps = {
        avoidPageBreak: true,
        align: "center",
    };

    render() {
        const pageBreakStyle: React.CSSProperties = this.props.avoidPageBreak
            ? { pageBreakInside: "avoid", ...this.props.style }
            : { ...this.props.style };

        const headStyle: React.CSSProperties =
            this.props.align === "left" ? { textAlign: "left" } : {};
        return (
            // eslint-disable-next-line react/forbid-elements
            <Card
                className={cn("PrintGroup", this.props.className)}
                style={pageBreakStyle}
                title={this.props.title}
                headStyle={headStyle}
                size="default"
            >
                {this.props.children}
            </Card>
        );
    }
}
